import { apiFetch } from "./api";
import type { Paginated } from "./platform-api";

export type NotificationType =
  | "MISSED_ATTENDANCE"
  | "OUTSIDE_GEOFENCE"
  | "PENDING_REQUEST"
  | "APPROVAL"
  | "SYSTEM"
  | "ANOMALY"
  | "ANNOUNCEMENT"
  | "REQUEST_APPROVED"
  | "REQUEST_REJECTED"
  | "REQUEST_NEEDS_CLARIFICATION"
  | "CHECK_IN_REMINDER"
  | "MISSED_CHECK_OUT";

export type NotificationSeverity = "INFO" | "WARNING" | "CRITICAL";

export interface NotificationItem {
  id: string;
  title: string;
  body: string;
  type: NotificationType;
  severity: NotificationSeverity;
  relatedEntityId: string | null;
  actionLink: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface ListNotificationsQuery {
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
  type?: NotificationType;
}

function toQuery(params: Record<string, unknown>): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "" || v === false) continue;
    usp.set(k, String(v));
  }
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const notificationsApi = {
  list: (q: ListNotificationsQuery = {}) =>
    apiFetch<Paginated<NotificationItem>>(
      `/notifications${toQuery(q as Record<string, unknown>)}`,
    ),

  unreadCount: () => apiFetch<{ count: number }>(`/notifications/unread-count`),

  markRead: (id: string) =>
    apiFetch<NotificationItem>(`/notifications/${id}/read`, { method: "PATCH" }),

  markAllRead: () =>
    apiFetch<{ updated: number }>(`/notifications/mark-all-read`, { method: "PATCH" }),
};
